import { createCommand } from '../../utils';
import { fullscreenQuery, rightPanelQuery } from '../queries';
import { escapePressed } from '../state';
import { CloseRightPanelCommand } from './CloseRightPanelCommand';

// Esc peels one thing at a time: fullscreen first, then the object sheet and its selection. While the edit
// dialog is open it is left alone.
export const PressEscapeCommand = createCommand('MAP_V2/PRESS_ESCAPE', async (_, { dispatch, getState }) => {
    const state = getState();
    if (state.mapV2.editDialog) {
        // The edit dialog handles its own Esc.
        return;
    }
    if (fullscreenQuery(state)) {
        dispatch(escapePressed());
    } else if (rightPanelQuery(state).open) {
        await dispatch(CloseRightPanelCommand());
    }
});
